import {get} from "lodash"
import {ConsentContext, ConsentDecisionInput, ConsentDecisionResult} from "types/consent"
import BaseService from "./Base"

class ConsentService extends BaseService {
    constructor() {
        super(process.env.REACT_APP_EDULAR_AUTH_API_BASE_URL)
    }

    async getConsentContext(requestId: string): Promise<ConsentContext> {
        try {
            const response = await this.get(`/oauth/consent/context?request_id=${encodeURIComponent(requestId)}`)
            return get(response, "data.data", {})
        } catch (e: any) {
            throw e?.response?.data ?? e
        }
    }

    async submitDecision(input: ConsentDecisionInput): Promise<ConsentDecisionResult> {
        try {
            const response = await this.post("/oauth/consent/decision", input)
            return get(response, "data.data", {})
        } catch (e: any) {
            throw e?.response?.data ?? e
        }
    }
}

export default ConsentService
